export const allowedRef = ['/', '/criar-conta', '/veiculos', '/condutor', '/extras'] as const;
